import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { IndividualService} from './individual.service'
import { Store } from "@ngrx/store";
import { Observable } from "rxjs/Observable";
import { NgxSpinnerService } from "ngx-spinner";
import { NavigationService } from 'src/app/core/services/navigation/navigation.service';
import { toastmessagesService } from "../../core/services/messages/toastmessages.service";
import { AppState, selectuserState } from 'src/store/reducers';
import { Subscription } from 'rxjs/Subscription';
import { DefaultUser } from 'src/store/actions/userActions';
@Component({
  selector: 'app-individual',
  templateUrl: './individual.component.html',
  styleUrls: ['./individual.component.scss']
})
export class IndividualComponent implements OnInit {
  individualForm: FormGroup;
  getState: Observable<any>;
  materialSubscription: Subscription;
  errorMessage;
  constructor( private fb: FormBuilder,
    private individual: IndividualService,
    private store: Store<any>,
    private spinner: NgxSpinnerService,
    private message: toastmessagesService,
    private navigate: NavigationService,
    ) 
    { 
      this.individualForm = fb.group(IndividualService.formFields());
      this.getState = this.store.select(selectuserState);
    }
    ngOnInit() {
      this.materialSubscription = this.getState.subscribe(state => {
        // this.errorMessage = state.errorMessage;
        
        if(state.action === 'material')
        {
          this.errorMessage = state.errorMessage;
          this.showMessage(state);
        // this.store.dispatch(new DefaultState({}));
        }
      })
    }
  
    ngOnDestroy() {
      this.materialSubscription.unsubscribe();
    }
  submit() {
    // alert("Hello World")
    if (this.individualForm.dirty && this.individualForm.valid) {
      this.spinner.show();
      let payload = {
        y_identifier:this.retrieveData("y_identifier"),
        is_single_user:1
      } 
      this.individual.dispatchMaterialProviderAction(payload);
    }
  } 

  retrieveData(key) {
    return this.individualForm.value[key];
  }
  showMessage(state) {
    if (state.success)
    {
      this.spinner.hide();
      this.sucesserrorMsg('successToastr', state.successMessage);
      this.store.dispatch(new DefaultUser({}));
      this.navigate.navigateTo('dashboard/create');
    }
    else if(!state.success && state.success !== null && state.success !== undefined)
    {
      this.spinner.hide();
      this.sucesserrorMsg('errorToastr', state.errorMessage);
    }
  }

  sucesserrorMsg(status, message)
  {
    this.message.messageHandler(status, message);
  }
}
